interface ITariffPrices {
  monthly: number
  yearly: number
  yearly_total: number
}

enum ReportStatus {
  SUCCESS = "SUCCESS",
  TRIAL_EXPIRED = "TRIAL_EXPIRED",
  DAILY_LIMIT = "DAILY_LIMIT",
  ERROR = "ERROR",
}

interface IGetReportsResponse {
  status: ReportStatus
  task_id: string | null
}

enum TariffPeriod {
  monthly = "monthly",
  yearly = "yearly",
}

interface ISignUpReportPayload {
  period: TariffPeriod
}

interface ISignUpReportResponse {
  payment_url: string | null
}

enum TariffCode {
  TRIAL = "TRIAL",
  REPORT = "REPORT",
  PRO = "PRO",
}

enum TariffSubcriptionStatus {
  ACTIVE = "ACTIVE",
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  EXPIRED = "EXPIRED",
  CANCELLED = "CANCELLED",
}

enum InvoiceStatus {
  AWAITING_PAYMENT = "AWAITING_PAYMENT",
  PAID = "PAID",
  FAILED = "FAILED",
  CANCELLED = "CANCELLED",
  REFUNDED = "REFUNDED",
}

interface IUserTariffResponse {
  tariff_code: TariffCode
  tariff_subscription_status: TariffSubcriptionStatus
  tariff_expiry_date?: string | null
}

interface ICancelTariffResponse {
  expiry_date: Date
}

interface IPaymentStatusResponse {
  status: InvoiceStatus
}

export { 
  ICancelTariffResponse,
  IGetReportsResponse,
  ISignUpReportPayload,
  ISignUpReportResponse,
  TariffPeriod,
  ITariffPrices,
  IUserTariffResponse,
  ReportStatus,
  TariffCode,
  TariffSubcriptionStatus,
  IPaymentStatusResponse,
  InvoiceStatus,
}
